import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { fonts } from '@theme/fontsCustomer';

interface Props {
  type: 'auto' | 'manual';
}

export const ModalBody = ({ type }: Props) => {
  const { t } = useTranslation();
  return (
    <ModalBodyContainer>
      <ErrorIcon />
      <ModalMainText>
        {type === 'auto' ? t('License_Retrieve.Auto_Modal_Title') : t('License_Retrieve.Manual_Modal_Title')}
      </ModalMainText>
      <ModalSubText>
        {type === 'auto' ? (
          <>
            {t('License_Retrieve.Confirm_Modal_Desc_1')}
            <br />
            {t('License_Retrieve.Confirm_Modal_Desc_2')}
          </>
        ) : (
          <>
            {t('License_Retrieve.Manual_Modal_Desc_1')}
            <br />
            {t('License_Retrieve.Manual_Modal_Desc_2')}
          </>
        )}
      </ModalSubText>
    </ModalBodyContainer>
  );
};

const ErrorIcon = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="18" r="18" fill="#FFEEF0" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10.5C17.4017 10.5 16.9166 10.985 16.9166 11.5833V20.25C16.9166 20.8483 17.4017 21.3333 18 21.3333C18.5983 21.3333 19.0833 20.8483 19.0833 20.25V11.5833C19.0833 10.985 18.5983 10.5 18 10.5ZM18 25.5C18.6904 25.5 19.25 24.9404 19.25 24.25C19.25 23.5596 18.6904 23 18 23C17.3096 23 16.75 23.5596 16.75 24.25C16.75 24.9404 17.3096 25.5 18 25.5Z"
        fill="#EA4A5A"
      />
    </svg>
  );
};

const ModalBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  align-items: center;
  justify-content: center;
`;

const ModalMainText = styled.span`
  margin-top: 20px;
  ${fonts.Headline7};
`;

const ModalSubText = styled.span<{ type?: string }>`
  margin-top: 8px;
  ${fonts.Body1};
  display: flex;
  justify-content: center;
  text-align: center;
  margin-bottom: 12px;
  color: ${props => props.theme.colors['text-gray-sub-darker']};
`;
